<div class="px-0 flex flex-col h-full min-h-0">
  <div class="flex justify-center">
    <app-ivy-face-animated [size]="ivySize"></app-ivy-face-animated>
  </div>

  <h2 class="text-xl font-semibold text-center text-gray-900 mb-8">
    What can I help you with right now?
  </h2>

  <div class="flex-1 min-h-0 overflow-y-auto space-y-3 pb-24 pr-1 no-scrollbar">
    <div *ngIf="showLoader" class="flex gap-2 flex-wrap justify-center">
      <app-loader></app-loader>
    </div>

    <div *ngIf="!showLoader && !this.selectedSuboption?.logOptions?.length"
      class="flex gap-1 flex-wrap justify-center sm:mb-4 md:mb-0">
      @for (option of this.suboptions; track option) {
      <button (click)="selectSuboption(option)" [ngStyle]="{
    'border': selectedSuboption?.option == option.option
                ? '2px solid rgba(123, 74, 226, 1)'
                : ('2px solid ' + (selectedSuboption?.color ?? '#FFFFFF'))
  }" class="group flex items-center bg-white rounded-full px-6 py-3 text-sm font-medium text-gray-800 shadow-sm hover:shadow-md transition-all row">
        {{ option.icon }} {{ option.option.display }}
      </button>
      }
    </div>

    <div *ngIf="!showLoader && this.selectedSuboption && this.selectedSuboption?.logOptions?.length > 0"
      class="flex gap-1 flex-wrap justify-center sm:mb-4 md:mb-0">
      @for (logOption of this.selectedSuboption?.logOptions ?? []; track logOption) {
      <button (click)="selectLogOption(logOption)"
        class="group flex items-center rounded-full px-4 py-3 text-sm font-medium text-gray-800 shadow-sm hover:shadow-md transition-all row"
        [ngStyle]="{
    'background-color': selectedSuboption?.color ?? '#FFFFFF',
    'border': selectedSuboption?.selectedOptions?.includes(logOption)
                ? '2px solid rgba(123, 74, 226, 1)'
                : ('2px solid ' + (selectedSuboption?.color ?? '#FFFFFF'))
  }">
        <img *ngIf="logOption.icon" class="size-8" [alt]="logOption.label" [src]="'assets/'+ logOption.icon" />
        <span class="ps-2">{{ logOption.label }}</span>
      </button>
      }
    </div>
  </div>

  <div *ngIf="showQuickActions"
    class="sticky bottom-0 bg-transparent flex gap-2 overflow-x-auto pb-2 pt-2 no-scrollbar">
    @for (category of this.quickActionsCategories; track category) {
    <div (click)="!showLoader && selectTabBarOption(category)" [class]="
             selectedOption === category
               ? 'rounded-full bg-black'
               : 'rounded-full p-px bg-gradient-to-tr from-[#81FFE1] to-[#B77FD8] hover:bg-[#7B4AE2]'
           " [class.pointer-events-none]="showLoader" [class.opacity-50]="showLoader">
      <button class="rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors" [class]="
            selectedOption === category
              ? 'bg-black text-white'
              : 'bg-white text-gray-700 hover:bg-white/80'
          ">
        {{ category.display }}
      </button>
    </div>
    }
  </div>
</div>
